import React from 'react';
import { Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IconWrapper } from 'lib/icons';
import { isKpiForLive, isKpiOnlyForLive } from 'components/constants';

export default function KpiPlatformIcons(props: { kpiKey: string }) {
  const { kpiKey } = props;
  const { t } = useTranslation();

  const onlyLive = isKpiOnlyForLive(kpiKey);
  const onLive = onlyLive || isKpiForLive(kpiKey);

  let label = t('kpi.platform.webappOnly', 'webapp only');
  if (onlyLive) label = t('kpi.platform.liveOnly', 'live only');
  else if (onLive) label = t('kpi.platform.webappAndLive', 'webapp + live');

  return (
    <Tooltip arrow title={label}>
      <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {!onlyLive && (
          <IconWrapper name="webAppNew" size="small" color="primary" noMargins viewBox="0 0 30 30" />
        )}
        {onLive && (
          <IconWrapper name="ipad" size="small" color="primary" noMargins viewBox="0 0 30 30" />
        )}
      </span>
    </Tooltip>
  );
}

export const kpiPlatformIcons = (option: { id: string }) => <KpiPlatformIcons kpiKey={option.id} />;
